module.exports = __webpack_public_path__ + "img/logo-lapiz.43ba64ee.svg";